export default "__VITE_ASSET__D9B0A7Vt__"